class LazyLoadCompanies {
  constructor (element) {
    this.element = element
    this.container = element.querySelector('[data-lazy-load-companies-target="container"]')
    this.loading = element.querySelector('[data-lazy-load-companies-target="loading"]')
    this.url = element.dataset.lazyLoadCompaniesUrlValue
    this.order = element.dataset.lazyLoadCompaniesParamsOrderValue
    this.page = element.dataset.lazyLoadCompaniesParamsPageValue
    this.isLoaded = false
    this.isLoading = false

    this.init()
  }

  init () {
    // スクロールイベントでの遅延読み込み
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.isLoaded && !this.isLoading) {
          this.loadMore()
        }
      })
    }, {
      rootMargin: '1000px 0px' // 1000px手前で読み込み開始
    })

    if (this.container) {
      observer.observe(this.container)
    }
  }

  async loadMore () {
    if (this.isLoaded || this.isLoading) return

    this.isLoading = true
    this.showLoading()

    try {
      // クエリパラメータを動的に構築
      const params = new URLSearchParams()
      if (this.order) params.append('order', this.order)
      if (this.page) params.append('page', this.page)
      const fetchURL = params.toString() ? `${this.url}?${params.toString()}` : this.url
      const response = await fetch(fetchURL, {
        method: 'GET',
        headers: {
          Accept: 'text/html',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })

      if (response.ok) {
        const html = await response.text()
        this.container.innerHTML = html

        this.isLoaded = true
      } else {
        console.error('Failed to load more companies:', response.status)
      }
    } catch (error) {
      console.error('Error loading more companies:', error)
    } finally {
      this.hideLoading()
      this.isLoading = false
    }
  }

  showLoading () {
    if (this.loading) {
      this.loading.classList.remove('d-none')
    }
  }

  hideLoading () {
    if (this.loading) {
      this.loading.classList.add('d-none')
    }
  }
}

// DOM読み込み完了後に初期化
document.addEventListener('DOMContentLoaded', () => {
  const lazyLoadCompaniesElements = document.querySelectorAll('[data-controller="lazy-load-companies"]')
  lazyLoadCompaniesElements.forEach(element => {
    new LazyLoadCompanies(element)
  })
})

export default LazyLoadCompanies
